import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { addSentryBreadcrumb } from './sentry';

export const useRouteBreadcrumbs = (): void => {
  const location = useLocation();

  useEffect(() => {
    addSentryBreadcrumb('navigation', `${location.pathname}${location.search}`, {
      hash: location.hash,
    });
  }, [location.hash, location.pathname, location.search]);
};

